import { render, staticRenderFns } from "./EventChatWidget.vue?vue&type=template&id=7d10d208&scoped=true&"
import script from "./EventChatWidget.vue?vue&type=script&lang=js&"
export * from "./EventChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./EventChatWidget.vue?vue&type=style&index=0&id=7d10d208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10d208",
  null
  
)

export default component.exports